import { createAsyncThunk } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
import { setOpenPurchase } from '../reducers/currentOrder/openPurchase';
import {
  getNestedItemStockBalancesData,
  getOpenPurchasePreviouslyStaged,
} from '../selectors';
import getItems from '../selectors/getItems';
import getUnenhancedOpenPurchase from '../selectors/getUnenhancedOpenPurchase';
import removeUnusedNestedChoiceSelections from '../utils/ordering/removeUnusedNestedChoiceSelections';
import { addStagedPurchase } from '../reducers/currentOrder/stagedPurchases';
import purchaseFromItem from '../utils/ordering/purchaseFromItem';

export const stageOpenPurchase = createAsyncThunk(
  '$stageOpenPurchase',
  async (
    data: {
      choiceSelections?: NestedChoiceSelections;
      enableUpsell?: boolean;
      itemId?: string;
      brandId?: string;
      upSellStaging?: boolean;
    },
    { getState, rejectWithValue, dispatch },
  ): Promise<any> => {
    const { choiceSelections, enableUpsell, itemId, brandId, upSellStaging } =
      data;
    try {
      const allItems = getItems(getState() as EntireFrontendState);
      const [stockBalanceDataMap] = getNestedItemStockBalancesData(undefined)(
        getState() as EntireFrontendState,
      );

      let openPurchase = upSellStaging
        ? createOpenPurchaseByUpsellItem(
            itemId,
            allItems,
            brandId,
            undefined,
            stockBalanceDataMap,
          )!
        : getUnenhancedOpenPurchase(getState() as EntireFrontendState)!;
      const _item = (allItems || {})[
        openPurchase.sizeId ? openPurchase.sizeId : openPurchase.itemId
      ];
      const { choiceSets } = _item;
      let _openPurchase = { ...openPurchase };
      if (choiceSets && openPurchase.sizeId) {
        const miamSet = choiceSets.some(set => set.displayType === 'makeameal');
        if (!miamSet) {
          _openPurchase.miam = undefined;
          _openPurchase.miamQuantityMap = undefined;
        }
      }
      if (choiceSelections) {
        _openPurchase = {
          ..._openPurchase,
          //@ts-ignore
          choiceSelections: {
            ..._openPurchase.choiceSelections,
            ...choiceSelections,
          },
        };

        dispatch(setOpenPurchase(_openPurchase));
      }

      const previouslyStaged = getOpenPurchasePreviouslyStaged(
        getState() as EntireFrontendState,
      );

      dispatch(
        addStagedPurchase(
          removeUnusedNestedChoiceSelections(_openPurchase!, allItems!),
        ),
      );

      return {
        purchase: removeUnusedNestedChoiceSelections(_openPurchase!, allItems!),
        previouslyStaged,
        enableUpsell,
        upSellStaging,
      };
    } catch (e) {
      console.error('Stage open purchase failed', { e });
      return rejectWithValue(e);
    }
  },
);

const createOpenPurchaseByUpsellItem = (
  itemId: string | undefined,
  allItems: SDict<Item> | undefined,
  brandId?: string,
  choiceSelections?: ChoiceSelections | NestedChoiceSelections,
  stockBalanceDataMap?: SDict<StockBalanceData>,
): _Purchase | null => {
  if (!itemId || !allItems || !allItems[itemId]) return null;
  return purchaseFromItem(
    allItems[itemId],
    uuidv4(),
    choiceSelections,
    undefined,
    brandId,
    undefined,
    stockBalanceDataMap,
  );
};
